module.exports = __webpack_public_path__ + "assets/images/project/constituencies/mountbatten-smc.jpg?v=8b3d133b";